export default function () {
    bindFields();
};

function bindFields() {
    $('.filter-text').keyup(filterCriteria);
}

function filterCriteria() {
    const searchText = this.value;
    const criteria = $(this.dataset.target);

    const fieldsToHide = criteria.toArray().filter(node =>

    /*  If the searchText cannot be located within node.textContent then node.textContent.toLowerCase().indexOf(searchText.toLowerCase()) will return -1.
        !~(-1) === true. Therefore, .filter() will include node in the fieldsToHide array.
        Resulting in nodes that do not contain the searchText to be placed in the array of nodes that receive the hide class. */
        !~node.textContent.toLowerCase().indexOf(searchText.toLowerCase())
    );

    criteria.removeClass('hide');
    fieldsToHide.forEach(field => field.classList.add('hide'));
}